import {Component, HostBinding, Input} from '@angular/core';
import {BillingVer202212StatusForLayout} from '../../layout/billing-ver202212-status-for-layout';
import {AuthorizationService} from '../../authorization/authorization.service';
import {UserBalanceService} from '../../layout/user-balance.service';
import {ModalWindowService} from '../../shared/modal-window/modal-window.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalWindowType} from '../../shared/modal-window/modal-window-type';

@Component({
  selector: 'app-top-up-balance-menu',
  templateUrl: './top-up-balance-menu.component.html',
})
export class TopUpBalanceMenuComponent {
  @HostBinding('class.header-menu-item') userSimBalance = true;
  @Input() balanceStatus: BillingVer202212StatusForLayout;

  constructor(
    public authorizationService: AuthorizationService,
    public userBalanceService: UserBalanceService,
    private modalWindowService: ModalWindowService,
    private translateService: TranslateService,
  ) {
  }


  openTopUpModalWindow() {
    this.modalWindowService.showWindow({
      modalWindowType: ModalWindowType.TopUpBalance,
      title: this.translateService.instant('Top-up of personal account balance'),
      text: this.translateService.instant('Top-up of personal account balance')
    });
  }
}
